






















































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  configService,
  CouponRequests,
  ExperienceAvailabilityRequests,
  ExperienceInquiryRequests,
  NoProfileGiftsRequests,
  NoProfileReservationsRequests,
  ProfileGiftsRequests,
  ProfileReservationsRequests,
  UtilitiesFunctions,
  UtilitiesRequests
} from "@/helpers";
import RouteTranslations from "@/locales/routerTranslations";
import formRules, { FormRules } from "@/helpers/formRules";
import { mapState } from "vuex";
import Reservation, { InvoiceForm } from "@/models/reservation";
import { User } from "@/models/user";
import Stripe from "../Stripe.vue";
import Dwspay from "../Dwspay.vue";
import Gift from "@/models/gift";
import { dwspayService } from "@/helpers/dwspayService";
import { BaseRequests } from "@/helpers/requests/BaseRequests";
import CustomDatePicker from "@/components/CustomDatePicker.vue";
import moment from "moment";
import Country from "@/models/country";
import "@/plugins/googleMaps";
import { ExperienceInquiry } from '@/models/experience-inquiry';
import NumericPrefix from "@/models/numeric-prefix";
import { ExperienceAvailability } from "@/models/experience-availability";

interface MyRules {
  name: FormRules[];
  surname: FormRules[];
  email: FormRules[];
  confirmEmail: FormRules[];
  numericCode: FormRules[];
  phoneNumber: FormRules[];
  birth_date: FormRules[];
  country: FormRules[];
  beneficiaryNotify: FormRules[];
  select: FormRules[];
  message: FormRules[];
  socialR: FormRules[];
  address: FormRules[];
  cap: FormRules[];
  city: FormRules[];
  province: FormRules[];
  state: FormRules[];
  cf: FormRules[];
  pi: FormRules[];
  idCode: FormRules[];
}

declare const fbq: any;

// Tapfiliate function is on window
declare const tap: (action: string, chargeId: string, amount: number, options: any) => {};

@Component({
  components: {
    Stripe,
    Dwspay,
    CustomDatePicker
  },
  computed: {
    ...mapState({
      bookingDetails: (state: any) => {
        console.info('state')
        console.info(state);
        return state.booking.bookingDetails
      },
      user: (state: any) => state.session.user
    })
  }
})
export default class BookingSummaryDetail extends Vue {
  bookingDetails!: any;
  user!: User;
  experience!: any;
  isOnline: boolean = false;
  translations: any = RouteTranslations;
  loading: boolean = false;
  visitReason = "";
  visitReasonTags = null;
  message = "";
  // savedMessage = "";
  privacyBoolean = false;
  privacyMarketingAccepted = false;
  privacyProfileAccepted = false;
  invoiceBoolean = false;
  numericCodeFormItem: any = null;
  phoneNumber = "";
  beneficiaryNotify = "";
  countryFormItem = ""
  profileFormItems: any = {};
  beneficiaryFormItems: any = {};
  optionalFormItems: any = {};
  shippingAddressFormItems: any = {};
  autoCompleteOptions: any = {
    componentRestrictions: {
      country: ['it']
    }
  };
  profileFormValid = false;
  shippingAddressFormValid = false;
  beneficiaryFormValid = false;
  phoneFormValid = false;
  numericFormValid = false;
  invoiceFormItems: any = {};
  invoiceFormValid = false;
  paymentMethodFormValid = false;
  buttonDisabled = false;
  confirmSave: any = "";
  cardElement: any;
  clientSecret: any = "";
  paymentOK = false;
  paymentLoading = false;
  inquirySubmitting = false;
  /** Prevents overlapping dwspay confirmPayment calls (async gap after click). */
  private isDwspayConfirmingPayment = false;
  bookingDetailsReady = false;
  reservationId = "";
  coupon: any = "";
  couponVerified = false;
  couponMessage: any = "";
  couponLoading = false;
  total = 0;
  previousTotal = 0;
  handleRoute = UtilitiesFunctions.handleRoute;
  radios = "radio-1";
  radioColor = "#BA324F";
  loaded: boolean = false;
  paidFor: boolean = false;
  serializedData: any = null;
  relationships: any = null;
  paypalEnabled: boolean = false;
  
  // DWSPay properties
  acceptDwspayPayment: boolean = false;
  dwspayEnabled: boolean = false;
  dwspayClientSecret: string | null = null;
  dwspayPaymentIntentId: string | null = null;
  /** True only after stripe.confirmPayment succeeds (not when draft PI exists). */
  dwspayPaymentConfirmed: boolean = false;
  isDwspayPaymentValid: boolean = false;
  isDwspayInitializing: boolean = false;
  dwspayDraftReservationId: string | null = null;
  private dwspayStatusChecked: boolean = false; // Flag to avoid multiple checks
  private readonly dwspaySuccessStatuses = ['succeeded', 'requires_capture', 'processing'];

  expandMarketing = false;
  expandProfiling = false;

  countries: Array<Country> = [];
  numericCodes: NumericPrefix[] = [];

  // !!! RULES KEYS MUST MATCH JSON LOCALES KEYS
  myRules: MyRules = {
    name: formRules.nameRules,
    surname: formRules.surnameRules,
    email: formRules.mandatoryEmailRules,
    confirmEmail: [],
    birth_date: [],
    country: formRules.mandatoryCountry,
    numericCode: formRules.mandatoryNumericCode,
    phoneNumber: formRules.mandatoryNumber,
    beneficiaryNotify: formRules.mandatoryDate,
    select: formRules.mandatorySelect,
    message: [],
    socialR: formRules.mandatoryField,
    address: formRules.mandatoryField,
    cap: formRules.mandatoryField,
    city: formRules.mandatoryField,
    province: formRules.mandatoryField,
    state: formRules.mandatoryField,
    cf: formRules.mandatoryTaxCodeRules,
    pi: formRules.mandatoryField,
    idCode: formRules.mandatoryField
  };
  redeemData: any;

  get dateFormatted() {
    return UtilitiesFunctions.dateFormatter(this.bookingDetails.startAt);
  }

  get startTimeFormatted() {
    return this.bookingDetails.time;
  }

  created() {
    // Check if returning from Satispay redirect BEFORE accessing bookingDetails.experience
    const params = new URLSearchParams(window.location.search);
    const redirectStatus = params.get('redirect_status');
    const paymentIntent = params.get('payment_intent');
    const rawReservationId = params.get('reservation_id');
    const reservationId = rawReservationId && rawReservationId.trim() !== '' ? rawReservationId.trim() : null;
    const isReturningFromSatispayRedirect = redirectStatus === 'pending' && !reservationId && paymentIntent;
    
    // If returning from Satispay redirect, handle it first before accessing bookingDetails
    if (isReturningFromSatispayRedirect) {
      this.handleDwspayRedirect();
      // Early return - handleDwspayRedirect will handle creating the reservation
      // Don't access bookingDetails.experience here as it might be null
      return;
    }
    
    // Normal flow: check bookingDetails
    if (!this.bookingDetails || !this.bookingDetails.experience) {
      console.warn('bookingDetails.experience is null, redirecting...');
      const toRoute = UtilitiesFunctions.handleRoute("home");
      this.$router.push(toRoute);
      return;
    }
    
    this.total = this.bookingDetails.total;
    this.previousTotal = this.bookingDetails.total;
    this.isOnline = (this.bookingDetails.experience.experienceTypeTags || []).some(t => t.code == 'smart');
    console.warn('a:>' + (!this.bookingDetails.priceLabels || !this.bookingDetails.priceLabels.size) && !this.bookingDetails.experience.isInquiry)
    if (!this.bookingDetails.adults && (!this.bookingDetails.priceLabels || !this.bookingDetails.priceLabels.length) && !this.bookingDetails.experience.isInquiry) {
      const toRoute = UtilitiesFunctions.handleRoute("home");
      // this.$router.push(toRoute);
      this.$router.go(-1);
    }
    this.$store.state.app.tagsList.forEach((tag: any) => {
      if (tag.code === "visit_reasons") this.visitReasonTags = tag.tags;
    });
    UtilitiesRequests.getCountries().then((list: Array<Country>) => {
      this.countries = list;
    });
    UtilitiesRequests.getNumericCodes().then((list: NumericPrefix[]) => {
      this.numericCodes = list;
    });
    
    // Handle dwspay redirect return (for other cases)
    this.handleDwspayRedirect();
    
    // Check dwspay status at checkout opening (like widget): call API to get true/false → true = dwspay, false = Stripe
    if (this.bookingDetails.experience && this.bookingDetails.experience.acceptStripePayments && !this.dwspayStatusChecked) {
      const wineryId = this.getWineryIdForDwspay(this.bookingDetails.experience);
      if (wineryId) {
        this.checkDwspayStatus(wineryId);
      } else {
        // No winery id → show Stripe (same as API false)
        this.dwspayStatusChecked = true;
        this.dwspayEnabled = false;
        this.acceptDwspayPayment = false;
      }
    }
  }

  get priceLabel() {
    return this.total > 0
      ? "€ " + this.total.toFixed(2)
      : this.$t("general.free");
  }

  mounted() {
    // Check if returning from Satispay redirect - skip GA tracking if experience is null
    const params = new URLSearchParams(window.location.search);
    const redirectStatus = params.get('redirect_status');
    const paymentIntent = params.get('payment_intent');
    const rawReservationId = params.get('reservation_id');
    const reservationId = rawReservationId && rawReservationId.trim() !== '' ? rawReservationId.trim() : null;
    const isReturningFromSatispayRedirect = redirectStatus === 'pending' && !reservationId && paymentIntent;
    
    // Skip GA tracking if returning from redirect and experience is null
    if (isReturningFromSatispayRedirect && (!this.bookingDetails || !this.bookingDetails.experience)) {
      this.bookingDetailsReady = true;
      return;
    }

    // Normal flow: proceed with GA tracking
    if (!this.bookingDetails || !this.bookingDetails.experience) {
      console.warn('bookingDetails.experience is null in mounted, skipping GA tracking');
      this.bookingDetailsReady = true;
      return;
    }

    const dataLayer: any = (window as any).dataLayer;

    if (this.bookingDetails.isGift) {
      //push step1 GA checkout behavior for Gift

      dataLayer.push({
        'event': 'EEcheckout',
        'ecommerce': {
          'checkout': {
            'actionField': { 'step': 1, 'option': this.bookingDetails.experience.title },
            'products': [{
              'name': this.bookingDetails.experience.title,
              'id': this.bookingDetails.experience.id,
              'quantity': this.bookingDetails.adults,
              'category': 'Gift',
              'brand': this.bookingDetails.experience.cellar && this.bookingDetails.experience.cellar.title

            }]


          }
        }
      });

    }



    else {

      //push step 1 GA checkout behavior for Reservation
      dataLayer.push({
        'event': 'EEcheckout',
        'ecommerce': {
          'checkout': {
            'actionField': { 'step': 1, 'option': this.bookingDetails.experience.title },
            'products': [{
              'name': this.bookingDetails.experience.title,
              'id': this.bookingDetails.experience.id,
              'quantity': this.bookingDetails.adults,
              'category': 'Reservation',
              'brand': this.bookingDetails.experience.cellar && this.bookingDetails.experience.cellar.title

            }]

          }
        }
      });
    }



    // this.payPalButtonSet();
    this.bookingDetailsReady = true;
    
    // Ensure dwspay status check is done at checkout opening (mounted hook)
    if (this.bookingDetails && this.bookingDetails.experience && this.bookingDetails.experience.acceptStripePayments && !this.dwspayStatusChecked) {
      const wineryId = this.getWineryIdForDwspay(this.bookingDetails.experience);
      if (wineryId) {
        this.checkDwspayStatus(wineryId);
      } else {
        this.dwspayStatusChecked = true;
        this.dwspayEnabled = false;
        this.acceptDwspayPayment = false;
      }
    }

    // Keys used in v-for forms
    const profileItems = ["name", "surname", "email", "confirmEmail"];
    const beneficiaryItems = ["name", "surname", "email", "confirmEmail"];
    const optionalItems = ["birth_date", "country"];
    const shippingAddressItems = ['country', 'addressLine1', 'addressLine2', 'city', 'province', 'region', 'zipcode']

    const invoiceItems = [
      "name",
      "surname",
      "socialR",
      "address",
      "cap",
      "city",
      "province",
      "state",
      "cf",
      "pi",
      "idCode",
      "email",
      "phoneNumber",
      "numericCode",
      "country"
    ];
    this.profileFormItems = this.buildInputModels(profileItems);
    this.beneficiaryFormItems = this.buildInputModels(beneficiaryItems);
    this.optionalFormItems = this.buildInputModels(optionalItems);
    this.shippingAddressFormItems = this.buildInputModels(shippingAddressItems);

    if (this.bookingDetails.redeem) {
      this.beneficiaryFormItems.beneficiary_name = "2";
    }

    this.invoiceFormItems = this.buildInputModels(invoiceItems);

    if (this.bookingDetails.redeem) {
      this.profileFormItems["email"] =
        this.bookingDetails.redeem.beneficiary_email ? this.bookingDetails.redeem.beneficiary_email.toLowerCase() : "";
      this.profileFormItems["name"] =
        this.bookingDetails.redeem.beneficiary_firstname || "";
      this.profileFormItems["surname"] =
        this.bookingDetails.redeem.beneficiary_lastname || "";
      this.profileFormItems["confirmEmail"] =
        this.bookingDetails.redeem.beneficiary_email ? this.bookingDetails.redeem.beneficiary_email.toLowerCase() : "";
    } else if (this.user) {
      this.profileFormItems["email"] = this.user.email || "";
      this.profileFormItems["name"] = this.user.firstName || "";
      this.profileFormItems["surname"] = this.user.lastName || "";
      this.profileFormItems["email"] = this.user.email || "";
      this.profileFormItems["confirmEmail"] = this.user.email || "";
      this.phoneNumber = this.user.phone || "";
      this.countryFormItem = this.countryFormItem || "";
    }
  }

  @Watch("profileFormValid")
  handleEmailCouponReset(val: boolean) {
    if (!val) {
      const hadVerifiedCoupon = this.couponVerified;
      this.coupon = "";
      this.couponMessage = "";
      this.couponVerified = false;
      this.total = this.previousTotal;
      if (hadVerifiedCoupon && this.radios === "radio-dwspay" && this.dwspayClientSecret) {
        this.dwspayPaymentIntentId = null;
        this.createDwspayDraftReservation();
      }
    }
  }

  /** Rimuove lo sconto e, con DWSPay attivo, ricrea un solo Payment Intent sul totale pieno (come il widget). */
  removeCoupon(): void {
    this.total = this.previousTotal;
    this.coupon = "";
    this.couponVerified = false;
    this.couponMessage = "";
    if (this.radios === "radio-dwspay" && this.dwspayClientSecret) {
      this.dwspayPaymentIntentId = null;
      this.createDwspayDraftReservation();
    }
  }

  getTermsUrl(): string {
    const redeemData = this.$store.state.booking.redeemData;

      if (redeemData && redeemData.experience) {
    if (redeemData.experience.terms_of_use_url) {
      return redeemData.experience.terms_of_use_url;
    } else {

      return '#';
    }
  }
    
    return this.handleRoute('terms');
  }

  handleTermsClick(event): void {
    const redeemData = this.$store.state.booking.redeemData;

    if (redeemData && redeemData.experience && !redeemData.experience.terms_of_use_url) {

      event.preventDefault();

      this.$store.dispatch("app/setSnackbarMessage", {
        message: this.$t("booking.summary.noTermsFromWinery"),
        color: "red",
      });
    }

  }

getPrivacyUrl(): string {
  const redeemData = this.$store.state.booking.redeemData;
  
  if (redeemData && redeemData.experience) {
    if (redeemData.experience.privacy_statement_url) {
      return redeemData.experience.privacy_statement_url;
    } else {

      return '#';
    }
  }
  
  return this.handleRoute('privacy');
}
  handlePrivacyClick(event): void {
    const redeemData = this.$store.state.booking.redeemData;
    
    if (redeemData && redeemData.experience && !redeemData.experience.privacy_statement_url) {

      event.preventDefault();
      
      this.$store.dispatch("app/setSnackbarMessage", {
        message: this.$t("booking.summary.noPrivacyPolicyFromWinery"),
        color: "red",
      });
    }

  }



  countryChanged(country: any) {
    this.autoCompleteOptions.componentRestrictions = {
      country: [country.iso]
    }
    this.shippingAddressFormItems['addressLine1'] = '';
    this.shippingAddressFormItems['addressLine2'] = '';
    this.shippingAddressFormItems['city'] = '';
    this.shippingAddressFormItems['province'] = '';
    this.shippingAddressFormItems['region'] = '';
    this.shippingAddressFormItems['zipcode'] = '';
  }

  numericCodeChanged(numericCode: any) {
    this.numericFormValid = !!numericCode
    const b = this.phoneNumber;
    this.phoneNumber = ""
    this.phoneNumber = b;
  }

  placeChanged(address: any) {
    const findByType = (type: string): string | undefined => {
      const v: any = address.address_components.find(e => e.types.some(ei => ei === type))
      return v ? v.short_name : null;
    }

    const city = findByType('locality');
    const region = findByType('administrative_area_level_1');
    const area1 = findByType('administrative_area_level_3');
    const area2 = findByType('administrative_area_level_2');

    this.shippingAddressFormItems['city'] = city;
    this.shippingAddressFormItems['province'] = area2 || area1;
    this.shippingAddressFormItems['region'] = region;
    this.shippingAddressFormItems['addressLine1'] = address.formatted_address;
  }

  areBeneficiaryDataValid() {
    if (this.bookingDetails.isGift) {
      return (
        this.beneficiaryFormValid &&
        !!this.beneficiaryNotify &&
        this.phoneNumber &&
        this.phoneFormValid &&
        this.numericFormValid
      );
    }
    return true;
  }

  verifyCoupon() {
    this.couponLoading = true;
    if (this.profileFormValid && !this.couponVerified) {
      const code = (this.coupon || "").trim();
      if (!code) {
        this.couponLoading = false;
        this.couponMessage = this.$t("booking.summary.couponInvalid");
        return;
      }
      // Valida sempre sul totale pieno (un solo aggiornamento PI dopo risposta ok, niente intent a ogni carattere)
      this.total = this.previousTotal;
      const baseTotal = this.previousTotal;
      const query = `?coupon_code=${encodeURIComponent(code)}&email=${this.profileFormItems.email}&experience_id=${this.bookingDetails.experience.id}&date=${this.bookingDetails.startAt}&total_cents=${Math.round(baseTotal * 100)}`;
      CouponRequests.fetchAll(query, true)
        .then((response: any) => {
          const [data] = response;
          this.couponLoading = false;
          let newPrice = baseTotal;
          let appliedDiscountStr = "";
          const totalScaled = baseTotal * 10000;
          if (data.discountType == "percent") {
            const percent = (totalScaled * data.discountPercent) / 100;
            newPrice = Math.round((totalScaled - percent) / 100) / 100;
            appliedDiscountStr = `${data.discountPercent}%`;
          } else if (data.discountType == "absolute") {
            const discount = data.discountCents / 100;
            newPrice = baseTotal - discount;
            appliedDiscountStr = "€ " + discount.toFixed(2);
          }

          this.couponVerified = true;
          this.couponMessage = `${this.$t("booking.summary.couponValid")}  ${appliedDiscountStr}`;
          this.total = newPrice;

          if (this.radios === "radio-dwspay" && this.dwspayClientSecret) {
            this.dwspayPaymentIntentId = null;
            this.createDwspayDraftReservation();
          }
        })
        .catch(() => {
          this.couponLoading = false;
          this.couponVerified = false;
          this.couponMessage = this.$t("booking.summary.couponInvalid");
        });
    } else {
      this.couponMessage = this.$t("booking.summary.couponError");
      this.couponLoading = false;
    }
  }

  setPaymentBoolean(value: boolean) {
    this.paymentOK = value;
  }

  @Watch('radios')
  onRadiosChangedWatcher(newVal: string) {
    this.handleRadiosChange(newVal);
  }

  @Watch('bookingDetails', { immediate: false, deep: true })
  onBookingDetailsChanged(newVal: any) {
    if (newVal && newVal.experience && newVal.experience.acceptStripePayments && !this.dwspayStatusChecked) {
      const wineryId = this.getWineryIdForDwspay(newVal.experience);
      if (wineryId) {
        this.checkDwspayStatus(wineryId);
      } else {
        this.dwspayStatusChecked = true;
        this.dwspayEnabled = false;
        this.acceptDwspayPayment = false;
      }
    }
  }

  /**
   * Get winery id for dwspay API (same as widget: company.id / cellar.id / company_id)
   */
  getWineryIdForDwspay(experience: any): string | null {
    if (!experience) return null;
    const id = (experience.company && experience.company.id) ||
      (experience.cellar && experience.cellar.id) ||
      experience.company_id;
    return id || null;
  }

  handleRadiosChange(newVal: string) {
    // When dwspay is selected, create draft reservation to get client secret (only if dwspay is actually enabled)
    if (newVal === 'radio-dwspay' && this.dwspayEnabled && this.acceptDwspayPayment && !this.dwspayClientSecret && !this.isDwspayInitializing) {
      this.createDwspayDraftReservation();
    } else if (newVal === 'radio-dwspay' && this.dwspayClientSecret && !this.isDwspayInitializing) {
      // Payment element will be initialized by Dwspay component when clientSecret prop changes
      // Just ensure paymentOK is reset
      this.paymentOK = false;
    }
  }

  onRadiosChanged(newVal: string) {
    // Handler for @change event on v-radio-group
    // newVal might be the value directly or an event object
    const value = typeof newVal === 'string' ? newVal : (this.radios || newVal);
   
    this.handleRadiosChange(value);
  }

  privacyAcceptAllChanged(v: any) {
    if (v) {
      this.privacyBoolean = v;
      this.privacyMarketingAccepted = v;
      this.privacyProfileAccepted = v;
    }
  }

  privacyProfileChanged() {
    if (!this.privacyMarketingAccepted) {
      this.privacyMarketingAccepted = this.privacyProfileAccepted;
    }
  }

  privacyMarketingChanged() {
    if (!this.privacyMarketingAccepted) {
      this.privacyProfileAccepted = false;
    }
  }

  emailMatchError(email: string, confirmationEmail: string) {
    return email === confirmationEmail
      ? ""
      : this.$t("formRules.confirmEmailError");
  }

  // saveMessage() {
  //   this.savedMessage = this.message;
  //   this.confirmSave = this.$t("booking.summary.commentSaved");
  //   setTimeout(() => {
  //     this.confirmSave = "";
  //   }, 2000);
  // }

  mapBeneficiaryFormItems() {
    const mappedObj = JSON.parse(JSON.stringify(this.beneficiaryFormItems));
    for (let [key, value] of Object.entries(mappedObj)) {
      const new_key = "beneficiary_" + key;
      mappedObj[new_key] = mappedObj[key];
      delete mappedObj[key];
    }
    return mappedObj;
  }

  buildBookingObject(provider?: 'stripe' | 'paypal' | 'dwspay', paypalData?: any) {
    const profileData = this.profileFormItems;
    const optionalFormItems = this.optionalFormItems;
    if (typeof this.bookingDetails.adults === "string") {
      this.$store.dispatch("booking/setBookingDetails", {
        adults: parseInt(this.bookingDetails.adults)
      });
    }
    if (typeof this.bookingDetails.children === "string") {
      this.$store.dispatch("booking/setBookingDetails", {
        children: parseInt(this.bookingDetails.children)
      });
    }

    // Build optionalData - include payment_intent_id for dwspay (like widget does)
    const optionalData: any = {
      birth_date: optionalFormItems['birth_date'] ? optionalFormItems['birth_date'] : null,
      country: this.countryFormItem,
    };
    
    // If payment_intent_id is available (for dwspay), add it to optionalData
    // This ensures the backend can find and update the existing payment intent instead of creating a new one.
    // Include it also for redeem+extra: when total > 0 even on a redeem, a real DWSPay payment was made.
    // Only skip if it's a pure redeem with zero extra (no payment intent was created).
    if (provider === 'dwspay' && this.dwspayPaymentIntentId) {
      optionalData.payment_intent_id = this.dwspayPaymentIntentId;
    }

    const localDeserializationData = {
      ...profileData,
      ...this.mapBeneficiaryFormItems(),
      ...this.bookingDetails,
      optionalData: optionalData,
      beneficiaryNotify: this.beneficiaryNotify,
      phone: this.prefix(this.numericCodeFormItem) + this.phoneNumber,
      privacyBoolean: this.privacyBoolean,
      privacyMarketingAccepted: this.privacyMarketingAccepted,
      privacyProfileAccepted: this.privacyProfileAccepted,
      message: this.message,
      coupon: this.coupon ? this.coupon : null,
      paypalData: paypalData ? paypalData : null,
      provider: provider,
      default_min_parties: this.bookingDetails.experience.minParties
    };
        if (this.bookingDetails.redeem && this.bookingDetails.giftId) {
      localDeserializationData.giftId = this.bookingDetails.giftId;
    }

    if (this.shippingAddressFormItems.addressLine1) {
      localDeserializationData.shippingAddress = { ...this.shippingAddressFormItems }
    }

    if (!this.bookingDetails.isGift) {
      const storeData = new Reservation().localDeserialization(
        this.bookingDetails
      );
      let serializedInvoice = null;
      if (this.invoiceBoolean) {
        const invoiceData = new InvoiceForm().deserialize(
          this.invoiceFormItems
        );
        serializedInvoice = invoiceData.requestSerialize();
      }
      localDeserializationData.invoiceObject = this.invoiceBoolean
        ? serializedInvoice
        : null;
    }

    const objModel = this.bookingDetails.isGift
      ? new Gift()
      : new Reservation();
    const data = objModel.localDeserialization(localDeserializationData);
    this.serializedData = data.requestSerialize();

    this.relationships = [];
    this.relationships.push({
      relName: "experience",
      models: { id: this.bookingDetails.experienceId, _type: "experience" }
    });
    const tagModels: any = [];
    if(this.bookingDetails.language) {
      tagModels.push({ id: this.bookingDetails.language.id, _type: "tag" });
    }
    if (this.visitReason && !this.bookingDetails.isGift)
      tagModels.push({ id: this.visitReason, _type: "tag" });

    this.relationships.push({
      relName: "tags",
      models: tagModels
    });
  }


  cleanObj(obj: any, keysToKeep: string[] = []) {
    const resObj = JSON.parse(JSON.stringify(obj));
    Object.entries(resObj).forEach(o =>
      (o[1] === null || o[1] === "") && keysToKeep.indexOf(o[0]) === -1
        ? delete resObj[o[0]]
        : 0
    );
    return resObj;
  }


  handleLinkTap(link: string) {
    const toRoute: string = this.translations[this.$i18n.locale][link].link;
    this.$router.push({ path: toRoute });
  }

  buildInputModels(keys: string[]) {
    function buildByInputKeys(acc: any, key: any) {
      return { ...acc, [key]: "" };
    }

    const object = keys.reduce(buildByInputKeys, {});
    return object;
  }

  updateGiftNotifyPicker(id: string, date: string) {
    this.beneficiaryNotify = date;
  }

  sendFbPixelData(type: string) {
    let data: any = null;

    switch (type) {
      case "AddPaymentInfo":
        data = {
          content_category: this.bookingDetails.isGift ? 'gift' : 'book',
          content_ids: [this.bookingDetails.experience.id],
          currency: this.bookingDetails.experience.priceCurrency,
          contents: [
            {
              'id': this.bookingDetails.priceLabel,
              'quantity': this.bookingDetails.adults
            },
            {
              'id': this.bookingDetails.price2Label,
              'quantity': this.bookingDetails.children
            }
          ],
          value: this.total
        };
        break;
      case "Purchase":
        data = {
          content_ids: [this.bookingDetails.experience.id],
          currency: this.bookingDetails.experience.priceCurrency,
          content_name: this.bookingDetails.experience.title,
          contents: [
            {
              'id': this.bookingDetails.priceLabel,
              'quantity': this.bookingDetails.adults
            },
            {
              'id': this.bookingDetails.price2Label,
              'quantity': this.bookingDetails.children
            }
          ],
          content_type: "product",
          value: this.total
        };
        break;
    }

    // fbq("track", type, data);
  }


  sendGTMData(data: any) {
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    let gtmData: any = {
      event: 'reservation',
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': data.data.id,
            'revenue': data.data.attributes.coupon ? parseFloat(data.data.attributes.total_amount) * (1 - data.data.attributes.coupon.discount_percent / 100) : data.data.attributes.total_amount,
            'coupon': data.data.attributes.coupon ? data.data.attributes.coupon.code : null
          },
          'products': [{
            'name': this.bookingDetails.experience.title,
            'id': this.bookingDetails.experience.id,
            'price': data.data.attributes.coupon ? parseFloat(this.bookingDetails.experience.price) * (1 - data.data.attributes.coupon.discount_percent / 100) : this.bookingDetails.experience.price,
            'category': data.data.type,
            'quantity': data.data.attributes.adults,
            'brand': this.bookingDetails.experience.cellar.title,
            'coupon': data.data.attributes.coupon ? data.data.attributes.coupon.code : null


          }]
        }
      }
    };

    //@ts-ignore
    window.dataLayer.push(gtmData);
  }

  handleRequestForInformation() {
    if (this.inquirySubmitting) {
      return;
    }
    this.inquirySubmitting = true;
    if (process.env.APP_ENV === "production") {
      this.sendFbPixelData("RequestForInformation");
    }
    this.createExperienceInquiry();
  }

  handleProceed() {
    // Check if bookingDetails is available
    if (!this.bookingDetails) {
      console.error('handleProceed: bookingDetails is null');
      this.loading = false;
      this.handlePaymentError('Unable to load booking details. Please try again.');
      return;
    }

    if (this.paymentLoading) {
      return;
    }
    this.paymentLoading = true;

    this.loading = true;

    if (this.bookingDetails.isGift) {
      this.loading = false;
      this.book()
    } else {
      // Check if experienceId is available
      if (!this.bookingDetails.experienceId) {
        console.error('handleProceed: bookingDetails.experienceId is null');
        this.loading = false;
        this.paymentLoading = false;
        this.handlePaymentError('Unable to load experience details. Please try again.');
        return;
      }

      this.getExperienceAvailability(
        this.bookingDetails.experienceId,
        this.bookingDetails.startAt,
        this.bookingDetails.time,
        this.getIsoOfSelectedLanguage
      )
        .then(availability => {
          this.loading = false;
          let totalGuests = this.getTotalGuests()
          if (totalGuests >= availability.calculcatedMinAdults
            && totalGuests <= (availability.calculcatedMaxAdults - availability.adultsCount)) {
            this.book();
          } else {
            this.paymentLoading = false;
            this.$store.dispatch("app/setSnackbarMessage", {
              message: this.$t("experienceView.availabilityError"),
              color: "red",
            });
          }
        })
        .catch((error: Error) => {
          this.loading = false;
          this.paymentLoading = false;
          console.log(error);
          this.$store.dispatch("app/setSnackbarMessage", {
            message: this.$t("experienceView.experienceNotValidErrorMessage"),
            color: "red",
          });
        });
    }
  }

  private book() {
    // Check if bookingDetails is available
    if (!this.bookingDetails) {
      console.error('book: bookingDetails is null');
      this.paymentLoading = false;
      this.handlePaymentError('Unable to load booking details. Please try again.');
      return;
    }

    // paymentLoading is set in handleProceed() before book() to prevent double-submit; do not toggle here
    // Determine provider: if dwspay is enabled, use dwspay, otherwise use stripe
    const provider = this.dwspayEnabled && this.radios === 'radio-dwspay' ? 'dwspay' : (this.radios === 'radio-1' ? 'stripe' : undefined);
    
    if (process.env.APP_ENV === "production") {
      this.sendFbPixelData("AddPaymentInfo");
    }
    
    if (this.total > 0) {
      if (provider === 'dwspay') {
        // Check if returning from Satispay redirect (payment already confirmed)
        // When redirect_status=pending and payment_intent is present, payment is already confirmed by Satispay
        const params = new URLSearchParams(window.location.search);
        const redirectStatus = params.get('redirect_status');
        const isReturningFromRedirect = redirectStatus === 'pending' && this.dwspayPaymentIntentId !== null;
        
        if (isReturningFromRedirect) {
          // Payment already confirmed by Satispay, just create reservation with payment_intent_id
          this.buildBookingObject('dwspay');
          if (this.bookingDetails.isGift) {
            this.createGift();
          } else {
            this.createReservation();
          }
        } else {
          // Normal flow: confirm payment FIRST (like widget), then create reservation with payment_intent_id
          this.submitDwspayPayment();
        }
      } else if (this.$refs.stripeComponent) {
        // For stripe, build booking object and create reservation first
        this.buildBookingObject(provider);
        if (this.bookingDetails.isGift) {
          this.createGift();
        } else {
          this.createReservation();
        }
      } else {
        this.$store.dispatch("app/setSnackbarMessage", {
          message: "Error: check Stripe Ref",
          color: "red"
        });
        this.paymentLoading = false;
      }
    } else {
      // For free reservations (e.g., redeemed gifts), build booking object first
      const provider = this.dwspayEnabled && this.radios === 'radio-dwspay' ? 'dwspay' : (this.radios === 'radio-1' ? 'stripe' : undefined);
      this.buildBookingObject(provider);
      if (this.bookingDetails.isGift) {
        this.createGift();
      } else {
        this.createReservation();
      }
    }
  }

  public getTotalGuests(): number {
    const adults = this.bookingDetails.adults || 0;
    const children = this.bookingDetails.children || 0
    const quantityLabelsTotal = this.bookingDetails.priceLabels.map(e => {
      return (e.quantity != null ? e.quantity : (e.qtd != null ? e.qtd : 0));
    }).reduce((x, y) => x + y, 0) || 0;
    const quantityExtrasTotal = this.bookingDetails.priceExtras.map(e => {
      return (e.quantity != null ? e.quantity : (e.qtd != null ? e.qtd : 0));
    }).reduce((x, y) => x + y, 0) || 0;

    let totalGuests = adults + children + quantityLabelsTotal + quantityExtrasTotal;

    return totalGuests;
  }

  getExperienceAvailability(
    experienceId: string,
    day: string,
    time: string,
    enableLangIso: string,
    lang: string = 'it'
  ): Promise<ExperienceAvailability> {
    const params: string[] = [];
    if (day) { params.push(`day=${this.bookingDetails.startAt}`); }
    if (time) { params.push(`time=${this.bookingDetails.time}`); }
    if (enableLangIso) { params.push(`enable_lang_iso=${enableLangIso}`); }
    if (lang) { params.push(`lang=${lang}`); }
    let queryParams = params.join("&");

    return new Promise((resolve, reject) => {
      resolve(ExperienceAvailabilityRequests
        .with({
          ExperienceId: experienceId
        })
        .fetchAll(queryParams));
    });
  }

  get getIsoOfSelectedLanguage() {
    return !!this.bookingDetails.language ? (this.bookingDetails.language.code as string).replace("lang_", "") : "";
  }

  createExperienceInquiry() {
    const pd = this.profileFormItems;
    const localDeserializationData = {
      firstname: pd.name,
      lastname: pd.surname,
      email: pd.email,
      phone: this.phoneNumber,
      privacy_profiling: this.privacyProfileAccepted,
      privacy_marketing: this.privacyMarketingAccepted,
      message: this.message,
      experience_id: this.bookingDetails.experience.id,
      country: this.optionalFormItems['country'] ? this.optionalFormItems['country'] : null

    };
    ExperienceInquiryRequests
      .create(new ExperienceInquiry().deserialize(localDeserializationData))
      .then((response: any) => {
        this.goToSuccessPage(response.data);
      })
      .catch((error: any) => {
        console.error(error)
      })
      .finally(() => {
        this.inquirySubmitting = false;
      });
  }

  //Da AGGIUNGERE FUNZIONE PER FAR PARTIRE LO STEP 2 DEL CHECKOUT BEHAVIOR


  createGift() {
    console.warn(this.serializedData)
    const giftModel = this.user ? ProfileGiftsRequests : NoProfileGiftsRequests;
    giftModel
      .create(this.cleanObj(this.serializedData, ["beneficiary_notify_at"]), this.relationships)
      .then((response: any) => {
        let order = response.data;
        const { attributes: data } = response.data.data;
        const paymentProvider = data.payment_provider || (this.dwspayEnabled && this.radios === 'radio-dwspay' ? 'dwspay' : 'stripe');
        
        if (this.total > 0) {
          // Check if payment was already confirmed (e.g., from submitDwspayPayment or returning from redirect)
          const isPaymentAlreadyConfirmed = this.dwspayPaymentConfirmed && paymentProvider === 'dwspay';
          
          if (isPaymentAlreadyConfirmed) {
            // Payment already confirmed (from submitDwspayPayment)
            // For gifts: call complete-payment to capture immediately
            const giftId = order.data.id;
            
            this.completeDwspayPayment(giftId)
              .then(() => {
                const amount = this.total;
                if (configService.env === 'production' && this.dwspayPaymentIntentId) {
                  tap(
                    'conversion',
                    this.dwspayPaymentIntentId,
                    amount,
                    {
                      meta_data: { reservation_id: order.data.id },
                      currency: this.bookingDetails.experience.priceCurrency
                    }
                  );
                }
                this.goToSuccessPage(order);
              })
              .catch((error: any) => {
                console.error('Error completing dwspay payment for gift:', error);
                // Even if complete-payment fails, the gift was created, so go to success
                // The webhook will handle the payment status update
                this.goToSuccessPage(order);
              });
            return;
          }
          
          this.processOrder(response)
            .then((result: any) => {
              // For dwspay, payment is handled differently - check if we need to call /pay endpoint
              if (paymentProvider === 'dwspay') {
                // For dwspay, payment is already confirmed, just go to success
                const amount = result.paymentIntent ? (result.paymentIntent.amount / 100) : this.total;
                if (configService.env === 'production' && result.paymentIntent) {
                  tap(
                    'conversion',
                    result.paymentIntent.id,
                    amount,
                    {
                      meta_data: { reservation_id: order.data.id },
                      currency: this.bookingDetails.experience.priceCurrency
                    }
                  );
                }
                this.goToSuccessPage(order);
              } else {
                // For stripe, call /pay endpoint
                BaseRequests(
                  () =>
                    configService.noProfileGifts +
                    "/" +
                    response.data.data.id +
                    "/pay",
                  "order",
                  () => {
                  }
                )
                  .create({ id: response.data.data.id })
                  .then(() => {
                    const amount = result.paymentIntent.amount / 100;
                    if (configService.env === 'production') {
                      tap(
                        'conversion',
                        result.paymentIntent.id,
                        amount,
                        {
                          meta_data: { reservation_id: order.data.id },
                          currency: this.bookingDetails.experience.priceCurrency
                        }
                      );
                    }
                    this.goToSuccessPage(order);
                  })
                  .catch((error: any) => {
                    this.handlePaymentError('An error was occurred');
                    this.paymentLoading = false;
                  });
              }
            })
            .catch(error => {
              this.paymentLoading = false;
            });
        } else {
          this.goToSuccessPage(order);
        }
      })
      .catch((error: any) => {
        this.handlePaymentError('Can\'t create gift');
        this.paymentLoading = false;
      });
  }

  handlePaymentError(errorMessage: string) {
    this.$store.dispatch("app/setSnackbarMessage", {
      message: errorMessage,
      color: "red"
    });
    this.paymentLoading = false;
    /*const toRoute = UtilitiesFunctions.handleRoute("paymentOk");
     const queryData: any = {
     payment: "ko"
     };
     if (this.bookingDetails.isGift) queryData.gift = true;
     this.$router.push({
     path: toRoute,
     query: queryData
     });
     this.$store.dispatch("booking/resetBookingDetails");*/
  }

  createReservation() {
    const reservationModel = this.user
      ? ProfileReservationsRequests
      : NoProfileReservationsRequests;
    reservationModel
      .create(this.serializedData, this.relationships)
      .then((response: any) => {
        this.handleReservationCreated(response);
      })
      .catch((error: any) => {
        console.error('[DEBUG] Reservation creation error:', error);
        if (error.data && error.data.error && error.data.error === 'gift_code_expired') {
          this.handlePaymentError(error.data.error);
        } else if (error.data && error.data.errors && error.data.errors[0]) {
          this.handlePaymentError(error.data.errors[0].detail);
        } else {
          this.handlePaymentError('An error occurred while creating the reservation. Please try again.');
        }
        this.paymentLoading = false;
      });
  }

  private createReservationAsync(): Promise<any> {
    const reservationModel = this.user
      ? ProfileReservationsRequests
      : NoProfileReservationsRequests;
    return reservationModel.create(this.serializedData, this.relationships);
  }

  private handleReservationCreated(response: any): void {
        let order = response.data;
        const { attributes: data } = response.data.data;
        const paymentProvider = data.payment_provider || (this.dwspayEnabled && this.radios === 'radio-dwspay' ? 'dwspay' : 'stripe');
        const metadata = {
          meta_data: { reservation_id: order.data.id },
          currency: this.bookingDetails.experience.priceCurrency
        };
        
        if (this.total > 0) {
          // Check if payment was already confirmed (e.g., from submitDwspayPayment or returning from redirect)
          const isPaymentAlreadyConfirmed = this.dwspayPaymentConfirmed && paymentProvider === 'dwspay';
          
          if (isPaymentAlreadyConfirmed) {
            // Payment already confirmed (from submitDwspayPayment)
            // For instant booking OR gift: call complete-payment to capture immediately
            // For non-instant booking: do NOT call complete-payment, let the host confirmation trigger the capture
            const reservationId = order.data.id;
            const isInstantBooking = data.instant_booking || false;
            const isGift = this.bookingDetails.isGift || false;
            
            if (isInstantBooking || isGift) {
              // Instant booking or gift: capture payment now
              this.completeDwspayPayment(reservationId)
                .then(() => {
                  const amount = this.total;
                  if (configService.env === 'production' && this.dwspayPaymentIntentId) {
                    tap(
                      'conversion',
                      this.dwspayPaymentIntentId,
                      amount,
                      metadata
                    );
                  }
                  this.goToSuccessPage(order);
                })
                .catch((error: any) => {
                  console.error('Error completing dwspay payment:', error);
                  // Even if complete-payment fails, the reservation was created, so go to success
                  // The webhook will handle the payment status update
                  this.goToSuccessPage(order);
                });
            } else {
              // Non-instant booking: do NOT capture payment yet
              // Payment will be captured when host confirms the reservation
              const amount = this.total;
              if (configService.env === 'production' && this.dwspayPaymentIntentId) {
                tap(
                  'conversion',
                  this.dwspayPaymentIntentId,
                  amount,
                  metadata
                );
              }
              this.goToSuccessPage(order);
            }
            return;
          }
          
          this.processOrder(response)
            .then((result: any) => {
              // For dwspay, payment is handled differently
              if (paymentProvider === 'dwspay') {
                // For dwspay, payment is already confirmed, just go to success
                const amount = result.paymentIntent ? (result.paymentIntent.amount / 100) : this.total;
                if (configService.env === 'production' && result.paymentIntent) {
                  tap(
                    'conversion',
                    result.paymentIntent.id,
                    amount,
                    metadata
                  );
                }
                this.goToSuccessPage(order);
              } else {
                // For stripe, normal flow
                const amount = result.paymentIntent.amount / 100;
                if (configService.env === 'production') {
                  tap(
                    'conversion',
                    result.paymentIntent.id,
                    amount,
                    metadata
                  );
                }
                this.goToSuccessPage(order);
              }
            })
            .catch(error => {
              this.paymentLoading = false;
            });
        } else {
          this.goToSuccessPage(order);
        }
  }

  processOrder(response: any) {
    return new Promise((resolve, reject) => {
      this.reservationId = response.data.data.id;
      const { attributes: data } = response.data.data;
      // Determine provider: if dwspay is enabled and selected, use dwspay, otherwise use stripe
      const paymentProvider = data.payment_provider || (this.dwspayEnabled && this.radios === 'radio-dwspay' ? 'dwspay' : 'stripe');
      const paymentClientSecret = data.payment_client_secret;
      
      if (!paymentClientSecret) {
        reject(new Error("client secret received invalid"));
        return;
      }

      // Check if payment was already confirmed (e.g., returning from redirect)
      const isPaymentAlreadyConfirmed = this.dwspayPaymentConfirmed && paymentProvider === 'dwspay';
      
      if (isPaymentAlreadyConfirmed) {
        // Payment already confirmed, just resolve
        resolve({ paymentIntent: { id: this.dwspayPaymentIntentId, status: 'succeeded' } });
        return;
      }

      if (paymentProvider === 'dwspay') {
        // Handle dwspay payment
        this.dwspayClientSecret = paymentClientSecret;
        this.dwspayDraftReservationId = this.reservationId;
        
        // Check if payment element is already initialized (from component)
        if (this.$refs.dwspayComponent && (this.$refs.dwspayComponent as any).isInitialized) {
          // Payment element already initialized, process payment
          setTimeout(async () => {
            try {
              const result = await this.handleDwspayPayment(this.reservationId, paymentClientSecret);
              // If we get here without redirect, payment was confirmed
              resolve({ paymentIntent: { id: this.dwspayPaymentIntentId || (result.paymentIntent && result.paymentIntent.id), status: 'succeeded' } });
            } catch (error) {
              reject(error);
            }
          }, 500);
        } else {
          // Initialize payment element
          this.isDwspayInitializing = true;
          dwspayService.initPaymentElement(paymentClientSecret, 'dwspay-payment-element', this.$i18n.locale)
            .then(() => {
              this.isDwspayInitializing = false;
              
              // Subscribe to payment element changes
              dwspayService.onPaymentElementChange((event: any) => {
                this.isDwspayPaymentValid = event.complete && !event.error;
                this.paymentOK = this.isDwspayPaymentValid;
              });
              
              // Wait a bit for payment element to be ready, then process
              setTimeout(async () => {
                try {
                  const result = await this.handleDwspayPayment(this.reservationId, paymentClientSecret);
                  // If we get here without redirect, payment was confirmed
                  resolve({ paymentIntent: { id: this.dwspayPaymentIntentId || (result.paymentIntent && result.paymentIntent.id), status: 'succeeded' } });
                } catch (error) {
                  reject(error);
                }
              }, 1000);
            })
            .catch((error: any) => {
              this.isDwspayInitializing = false;
              reject(error);
            });
        }
      } else {
        // Handle stripe payment (existing logic)
        this.clientSecret = paymentClientSecret;
        setTimeout(() => {
          //@ts-ignore
          this.$refs.stripeComponent.stripePaymentHandler()
            .then((result: any) => {
              if (result.error) {
                this.handlePaymentError(result.error.message);
                reject(result.error);
              } else {
                resolve(result);
              }
            })
            .catch((error: any) => {
              reject(error);
            });
        }, 0);
      }
    });
  }

  get today() {
    return moment().toISOString();
  }

  goToSuccessPage(data: any) {
    if (process.env.APP_ENV === "production") {
      this.sendFbPixelData("Purchase");
    }
    this.sendGTMData(data);
    const toRoute = UtilitiesFunctions.handleRoute("paymentOk");
    const queryData: any = {
      payment: "ok"
    };
    if (this.bookingDetails.isGift) queryData.gift = true;
    if (this.bookingDetails.experience.instantBooking) queryData.instantBooking = true;
    queryData.isInquiry = this.bookingDetails.experience.isInquiry;
    this.$router.push({
      path: toRoute,
      query: queryData
    });
    this.$store.dispatch("booking/resetBookingDetails");
  }

  // Paypal related methods - disabled on divinea.com
  payPalButtonSet() {
    const script = document.createElement("script");
    const f = (params) => Object.keys(params).map(key => `${key}=${params[key]}`).join('&')
    const merchantId = this.bookingDetails.experience.paypalAccount
    let queryData: any = {
      currency: 'EUR',
      intent: 'authorize'
    };

    if (merchantId)
      queryData = {
        ...queryData,
        'client-id': configService.paypalPlatformPublishKey,
        'merchant-id': merchantId
      }
    else
      queryData = {
        ...queryData,
        'client-id': configService.paypalPublishKey
      }

    script.src = `https://www.paypal.com/sdk/js?${f(queryData)}`;
    script.addEventListener("load", this.setLoaded);
    document.body.appendChild(script);
  }

  setLoaded() {
    this.loaded = true;
    const paypal = (window as any).paypal;

    paypal.Buttons({
      style: {
        layout: "horizontal",
        color: "white"
      },
      createOrder: (data, actions) => this.paypalCreateOrderInBackend(data, actions),
      onApprove: (data, actions) => this.paypalApproveOrderAndPromote(data, actions),
      onError: (error: any) => {
        //qui bisogna chiudere il dialog e gestire l'errore con snackbar e fare il redirect alla pagina SuccessPayment
        this.handlePaymentError(error.message);
      }
    })
      .render(this.$refs.paypal);
  }

  paypalCreateOrderInBackend(_: any, actions: any) {
    return this
      .createReservationWithPaypal(null)
      .then(response => {
        const { attributes: data } = response.data.data;
        return data.paypal_data.order_id;
      })
  }

  paypalApproveOrderAndPromote(data, actions) {
    this.$store.dispatch("app/setDialog", {
      type: "payPalPaymentStatus",
      state: true,
      persistent: true
    });
    const { orderID } = data;
    const submitAuthorizationID = (paypal_data) => {
      return fetch(configService.payments, {
        method: 'POST',
        body: JSON.stringify({ paypal_data }),
        headers: { 'Content-Type': 'application/json' }
      }).then(res => res.json())
    }
    actions.order
      .authorize()
      .then((authorization: any) => {
        const authorizationID =
          authorization.purchase_units[0].payments.authorizations[0].id;
        this.paidFor = true;
        return Promise.all(
          [submitAuthorizationID({
            order_id: orderID,
            authorization_id: authorizationID
          }),
          Promise.resolve(orderID)]);
      })
      .then((data: any) => {
        const response = data[0];
        const orderID: string = data[1];
        this.$store.dispatch("app/closeDialog");
        this.goToSuccessPage(response);
      })
      .catch((error: any) => {
        //qui bisogna chiudere il dialog e gestire l'errore con snackbar
        if (this.paidFor) console.log("handle refund");
        this.$store.dispatch("app/closeDialog");
        this.$store.dispatch("app/setSnackbarMessage", {
          message: `PAYPAL ERROR1: ${error.message}`,
          color: "red"
        });
        this.handlePaymentError(error.data.errors[0].detail);
      });
  }

  paypalCreateOrder(data: any, actions: any) {
    return actions.order.create({
      purchase_units: [
        {
          description: this.bookingDetails.experience.title,
          amount: {
            currency_code: "EUR",
            value: this.total
          }
        }
      ]
    });
  }

  paypalOnApprove(data: any, actions: any) {
    this.$store.dispatch("app/setDialog", {
      type: "payPalPaymentStatus",
      state: true,
      persistent: true
    });
    const { orderID } = data;
    actions.order
      .authorize()
      .then((authorization: any) => {
        var authorizationID =
          authorization.purchase_units[0].payments.authorizations[0].id;
        this.paidFor = true;
        return Promise.all(
          [this.createReservationWithPaypal({
            orderID,
            authorizationID
          })
            , Promise.resolve(orderID)]);
      })
      .then((data: any) => {
        const response = data[0];
        const orderID: string = data[1];
        this.$store.dispatch("app/closeDialog");
        // const amount = response.data.data.attributes.total_amount;
        // if (configService.env === 'production') {
        //   tap(
        //       'conversion',
        //       orderID,
        //       amount,
        //       { meta_data: { reservation_id: response.data.data.id } }
        //   );
        // }
        this.goToSuccessPage(response.data);
      })
      .catch((error: any) => {
        //qui bisogna chiudere il dialog e gestire l'errore con snackbar
        if (this.paidFor) console.log("handle refund");
        this.$store.dispatch("app/closeDialog");
        this.$store.dispatch("app/setSnackbarMessage", {
          message: `PAYPAL ERROR1: ${error.message}`,
          color: "red"
        });
        this.handlePaymentError(error.data.errors[0].detail);
      });
  }

  createReservationWithPaypal(paypalData?: any) {
    this.buildBookingObject('paypal', paypalData);
    if (process.env.APP_ENV === "production") {
      this.sendFbPixelData("AddPaymentInfo");
    }

    let model = null;

    if (this.bookingDetails.isGift)
      model = this.user ? ProfileGiftsRequests : NoProfileGiftsRequests;
    else
      model = this.user
        ? ProfileReservationsRequests
        : NoProfileReservationsRequests;

    return model.create(
      this.bookingDetails.isGift
        ? this.cleanObj(this.serializedData, ["beneficiary_notify_at"])
        : this.serializedData,
      this.relationships
    );
    // return Promise.reject(new Error("error creating reservation"));
    // return Promise.resolve();
  }

  displayNumericSlice(numeric: NumericPrefix): string {
    if (!numeric) return '';
    return `+${numeric.phonePrefix} | ${numeric.isoCode3.join(", ")}`
  }

  prefix(numeric: any): string {
    if (!!numeric && !!numeric.phonePrefix)
      return '+' + numeric.phonePrefix + ' '
    else
      return ''
  }

  /**
   * Handle dwspay redirect return - similar to widget logic
   */
  handleDwspayRedirect(): void {
    const params = new URLSearchParams(window.location.search);
    const redirectStatus = params.get('redirect_status');
    // Clean reservation_id: trim whitespace and treat empty/whitespace-only strings as null
    const rawReservationId = params.get('reservation_id');
    const reservationId = rawReservationId && rawReservationId.trim() !== '' ? rawReservationId.trim() : null;
    const paymentIntent = params.get('payment_intent');
    const isReservation = params.get('is_reservation') === 'true';

    // Case 1: Success redirect with reservation_id
    if (redirectStatus && this.dwspaySuccessStatuses.includes(redirectStatus) && reservationId) {
      const toRoute = UtilitiesFunctions.handleRoute("paymentOk");
      const queryData: any = {
        payment: "ok"
      };
      if (this.bookingDetails && this.bookingDetails.isGift) queryData.gift = true;
      if (this.bookingDetails && this.bookingDetails.experience && this.bookingDetails.experience.instantBooking) {
        queryData.instantBooking = true;
      }
      this.$router.push({
        path: toRoute,
        query: queryData
      });
      this.$store.dispatch("booking/resetBookingDetails");
      return;
    }

    // Case 2: Pending redirect with payment_intent (needs to create order)
    // Satispay redirect: payment already confirmed, just need to create reservation
    if (redirectStatus === 'pending' && !reservationId && paymentIntent) {
      this.dwspayPaymentIntentId = paymentIntent;
      this.radios = "radio-dwspay";
      // Ensure dwspay is enabled (needed for book() to recognize dwspay provider)
      this.dwspayEnabled = true;
      this.acceptDwspayPayment = true;
      
      // Wait for booking details to be ready, then create order
      if (this.bookingDetailsReady) {
        this.createOrderWithDwspayPaymentIntent();
      } else {
        setTimeout(() => {
          if (this.bookingDetailsReady) {
            this.createOrderWithDwspayPaymentIntent();
          }
        }, 1000);
      }
    }
  }

  /**
   * Create order when returning from dwspay redirect with payment_intent
   * Similar to widget: when returning from Satispay redirect, create reservation directly
   */
  createOrderWithDwspayPaymentIntent(): void {
    if (!this.dwspayPaymentIntentId) {
      console.error('createOrderWithDwspayPaymentIntent: dwspayPaymentIntentId is null');
      return;
    }

    // Check if bookingDetails.experience is available
    // If not, wait a bit and retry (data might still be loading from Vuex store)
    if (!this.bookingDetails || !this.bookingDetails.experience) {
      // Wait up to 3 seconds for bookingDetails to be available
      let retries = 0;
      const maxRetries = 30; // 30 * 100ms = 3 seconds
      const checkInterval = setInterval(() => {
        retries++;
        if (this.bookingDetails && this.bookingDetails.experience) {
          clearInterval(checkInterval);
          this.handleProceed();
        } else if (retries >= maxRetries) {
          console.error('createOrderWithDwspayPaymentIntent: bookingDetails.experience still not available after waiting');
          clearInterval(checkInterval);
          this.handlePaymentError('Unable to load booking details. Please try again.');
        }
      }, 100);
      return;
    }

    // Proceed with booking
    this.handleProceed();
  }

  /**
   * Check if DWSPay is enabled for this winery
   * This determines which payment form to show:
   * - If enabled: true -> show dwspay form (new), hide stripe form
   * - If enabled: false -> show stripe form (old), hide dwspay form
   * 
   * Logic matches widget: if acceptDwspayPayment is true, acceptStripePayment becomes false
   */
  async checkDwspayStatus(wineryId: string): Promise<void> {
    // Mark that we've checked dwspay status to avoid multiple calls
    this.dwspayStatusChecked = true;
    
    // Optional: force Stripe (no wspayments) via URL e.g. ?payment=stripe or ?dwspay=false
    const params = new URLSearchParams(window.location.search);
    if (params.get('payment') === 'stripe' || params.get('dwspay') === 'false') {
      this.acceptDwspayPayment = false;
      this.dwspayEnabled = false;
      console.debug('DWSPay disabled by URL param (?payment=stripe or ?dwspay=false), using Stripe only');
      return;
    }
    
    // Check if bookingDetails.experience is available
    if (!this.bookingDetails || !this.bookingDetails.experience) {
      console.warn('checkDwspayStatus: bookingDetails.experience is null, skipping dwspay check');
      this.acceptDwspayPayment = false;
      this.dwspayEnabled = false;
      return;
    }

    // DWSPay is available when Stripe is enabled for experience AND winery has dwspay integration
    this.acceptDwspayPayment = false;
    this.dwspayEnabled = false;
    
    const hasStripe = this.bookingDetails.experience.acceptStripePayments;
    
    if (!hasStripe) {
      this.acceptDwspayPayment = false;
      this.dwspayEnabled = false;
      return;
    }
    
    try {
      // Call API: GET /api/v1/wspayments/accounts/winery/{wineryId}/dwspay
      console.debug('Checking dwspay status: GET wspayments/accounts/winery/' + wineryId + '/dwspay');
      const dwspayStatusResponse = await dwspayService.checkDwspayStatus(wineryId);
      const isDwspayEnabled = dwspayStatusResponse && dwspayStatusResponse.enabled === true;
      this.dwspayEnabled = isDwspayEnabled;
      
      if (!isDwspayEnabled) {
        this.acceptDwspayPayment = false;
        console.debug('DWSPay status: backend returned enabled=false → using Stripe only');
        return;
      }
      
      // Backend returned enabled: true – check payment methods
      const paymentMethodsResponse = await dwspayService.getPaymentMethods(wineryId);
      const paymentMethods = paymentMethodsResponse.payment_methods || paymentMethodsResponse.paymentMethods || [];
      const allowedTypes = ['card', 'satispay', 'klarna', 'google_pay', 'apple_pay'];
      const hasAllowedPaymentMethods = paymentMethods.length === 0 ||
        paymentMethods.some((m: string) => allowedTypes.includes(m));
      
      this.acceptDwspayPayment = hasStripe && isDwspayEnabled && hasAllowedPaymentMethods;
      
      if (this.acceptDwspayPayment && this.radios === 'radio-1') {
        this.radios = 'radio-dwspay';
      }
      
      console.debug('DWSPay status: backend returned enabled=true → showing dwspay. If create-payment-intent fails we will fall back to Stripe.', {
        wineryId,
        enabled: isDwspayEnabled,
        connected: (dwspayStatusResponse && dwspayStatusResponse.connected) || false,
        stripe_account_connect_id: (dwspayStatusResponse && dwspayStatusResponse.stripe_account_connect_id) || null,
        hasAllowedPaymentMethods,
        acceptDwspayPayment: this.acceptDwspayPayment
      });
    } catch (error) {
      console.error('Error checking dwspay status:', error);
      this.acceptDwspayPayment = false;
      this.dwspayEnabled = false;
    }
  }

  /**
   * Create a draft reservation for dwspay to obtain the client secret
   * This allows the Payment Element to initialize when the payment method is selected
   * Similar to widget's createDwspayDraftReservation()
   */
  private createDwspayDraftReservation(): void {
    if (this.isDwspayInitializing) {
      return;
    }
    // Only create payment intent when dwspay is actually enabled (avoid calling API if we should show Stripe)
    if (!this.dwspayEnabled || !this.acceptDwspayPayment) {
      return;
    }

    if (!this.bookingDetails.experience || !this.bookingDetails.experience.cellar || !this.bookingDetails.experience.cellar.id) {
      this.isDwspayInitializing = false;
      return;
    }

    const total = this.total;
    if (total <= 0) {
      this.isDwspayInitializing = false;
      return;
    }

    this.isDwspayInitializing = true;

    const wineryId = this.bookingDetails.experience.cellar.id;
    const amountCents = Math.round(total * 100); // Convert to cents
    const currency = this.bookingDetails.experience.priceCurrency || 'EUR';

    // Gift → capture immediately; instant booking (incl. gift redeem + extra) → automatic;
    // non-instant reservation → manual (host confirms before capture).
    // Gift redeem fee fix relies on reservation-before-confirm setting portal=gift-redeem on the PI first.
    const isGift = this.bookingDetails.isGift || false;
    const isInstantBooking = this.bookingDetails.experience && this.bookingDetails.experience.instantBooking === true;
    const captureMethod = (isGift || isInstantBooking) ? 'automatic' : 'manual';

    // Create payment intent to get client secret
    // API: /api/v1/wspayments/dwspay/create-payment-intent
    const url = `${configService.apiEndpoint}/wspayments/dwspay/create-payment-intent`;
    const payload: any = {
      wineryId: wineryId,
      amount: amountCents,
      currency: currency.toLowerCase(),
      captureMethod: captureMethod
    };

    // Do not pass giftId/redeem on draft PI create: WSPayments staging rejects portal=gift-redeem
    // at this step (400). Gift-redeem portal is set by backend on reservation before confirm.

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then((response) => {
        if (!response.ok) {
          return response.text().then((text) => {
            let detail = text;
            try {
              const parsed = JSON.parse(text);
              detail = parsed.error || parsed.message || text;
            } catch (_e) { /* keep raw text */ }
            throw new Error(`Failed to create payment intent: ${response.status} ${detail}`);
          });
        }
        return response.json();
      })
      .then((response: any) => {
        // Extract client secret and payment intent ID from response
        const clientSecret = response.client_secret || response.clientSecret || response.payment_client_secret;
        const paymentIntentId = response.id || response.payment_intent_id || response.paymentIntentId;

        if (clientSecret) {
          this.dwspayClientSecret = clientSecret;
        } else {
          this.handlePaymentError('Failed to get payment client secret');
          this.isDwspayInitializing = false;
          return;
        }

        // Store payment intent ID to pass to backend when creating order
        if (paymentIntentId) {
          this.dwspayPaymentIntentId = paymentIntentId;
        } else {
          // Extract payment intent ID from client secret if not provided
          if (clientSecret && clientSecret.startsWith('pi_')) {
            const parts = clientSecret.split('_secret_');
            if (parts.length > 0) {
              this.dwspayPaymentIntentId = parts[0];
            }
          }
        }

        this.isDwspayInitializing = false;
      })
      .catch((error) => {
        this.isDwspayInitializing = false;
        console.error('Error creating dwspay draft reservation:', error);
        this.handlePaymentError('Failed to initialize payment method. Please try again.');
        // Fallback to Stripe when dwspay fails (e.g. not connected / 500)
        this.dwspayEnabled = false;
        this.acceptDwspayPayment = false;
        this.dwspayClientSecret = null;
        this.dwspayPaymentIntentId = null;
        this.radios = 'radio-1';
      });
  }

  /**
   * Handle dwspay payment confirmation
   */
  async handleDwspayPayment(reservationId: string, clientSecret: string): Promise<any> {
    if (!clientSecret) {
      throw new Error('Payment client secret not available');
    }

    const isReady = await dwspayService.waitForPaymentElementReady(5000);
    if (!isReady) {
      throw new Error('Payment Element initialization timeout');
    }

    const confirmResult = await dwspayService.confirmPayment(clientSecret, {
      reservation_id: reservationId,
      is_reservation: !this.bookingDetails.isGift ? 'true' : 'false'
    });

    if (confirmResult.error) {
      throw new Error(confirmResult.error.message || 'Payment confirmation failed');
    }

    const paymentStatus = (confirmResult.paymentIntent && confirmResult.paymentIntent.status) || 'unknown';
    if (paymentStatus === 'requires_payment_method') {
      throw new Error('Payment method confirmation failed');
    }

    // Store payment intent ID
    if (confirmResult.paymentIntent && confirmResult.paymentIntent.id) {
      this.dwspayPaymentIntentId = confirmResult.paymentIntent.id;
    }

    // If payment requires redirect (e.g., 3D Secure), Stripe will handle it automatically
    // Otherwise, payment is confirmed and we can proceed
    return confirmResult;
  }

  /**
   * Complete dwspay payment by calling backend endpoint
   * This will capture payment for instant booking or defer capture for non-instant booking
   */
  async completeDwspayPayment(reservationId: string): Promise<void> {
    try {
      const token = this.$store.state.session && this.$store.state.session.token;
      const headers: Record<string, string> = { 'Content-Type': 'application/json' };
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const response = await fetch(`${configService.newApiEndpoint}/reservations/${reservationId}/complete-payment`, {
        method: 'POST',
        headers
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('Complete payment result:', result);
      return result;
    } catch (error) {
      console.error('Error completing dwspay payment:', error);
      throw error;
    }
  }

  /**
   * Dwspay flow: confirm payment on frontend (Stripe only), then create reservation with order
   * containing the payment intent. No "confirm payment" call to backend.
   * Similar to widget's submitDwspayPayment()
   */
  private async submitDwspayPayment(): Promise<void> {
    if (this.isDwspayConfirmingPayment) {
      return;
    }

    if (this.bookingDetails.isGift && !this.areBeneficiaryDataValid()) {
      this.handlePaymentError(this.$t("formRules.mandatory") as string);
      return;
    }

    const clientSecret = this.dwspayClientSecret;
    if (!clientSecret || !this.dwspayPaymentIntentId) {
      this.handlePaymentError('Payment not ready. Please complete the payment form.');
      return;
    }

    this.isDwspayConfirmingPayment = true;
    try {
      const isReady = await dwspayService.waitForPaymentElementReady(5000);
      if (!isReady) {
        this.handlePaymentError('Payment Element initialization timeout. Please try again.');
        return;
      }

      const isGiftRedeem = !!(this.bookingDetails.redeem && this.bookingDetails.giftId && !this.bookingDetails.isGift);

      // Gift redeem: create reservation first so backend sets portal=gift-redeem before Stripe confirm
      if (isGiftRedeem) {
        this.buildBookingObject('dwspay');
        const reservationResponse = await this.createReservationAsync();
        const reservationId = reservationResponse.data.data.id;

        const confirmResult = await dwspayService.confirmPayment(clientSecret, {
          reservation_id: reservationId,
          is_reservation: 'true'
        });

        if (confirmResult.error) {
          this.handlePaymentError(confirmResult.error.message || 'Payment confirmation failed');
          return;
        }

        const paymentStatus = (confirmResult.paymentIntent && confirmResult.paymentIntent.status) || 'unknown';
        if (paymentStatus === 'requires_payment_method') {
          this.handlePaymentError('Payment method confirmation failed. Please try again.');
          return;
        }

        if (confirmResult.paymentIntent && confirmResult.paymentIntent.id) {
          this.dwspayPaymentIntentId = confirmResult.paymentIntent.id;
        }
        this.dwspayPaymentConfirmed = true;

        await this.completeDwspayPayment(reservationId);
        this.goToSuccessPage(reservationResponse.data);
        return;
      }

      const confirmResult = await dwspayService.confirmPayment(clientSecret, {
        reservation_id: '',
        is_reservation: !this.bookingDetails.isGift ? 'true' : 'false'
      });

      if (confirmResult.error) {
        this.handlePaymentError(confirmResult.error.message || 'Payment confirmation failed');
        return;
      }

      const paymentStatus = (confirmResult.paymentIntent && confirmResult.paymentIntent.status) || 'unknown';
      if (paymentStatus === 'requires_payment_method') {
        this.handlePaymentError('Payment method confirmation failed. Please try again.');
        return;
      }

      // Store payment intent ID from confirmed payment
      if (confirmResult.paymentIntent && confirmResult.paymentIntent.id) {
        this.dwspayPaymentIntentId = confirmResult.paymentIntent.id;
      }
      this.dwspayPaymentConfirmed = true;

      // Payment confirmed, now create reservation/gift with payment_intent_id in optional_data
      this.buildBookingObject('dwspay');
      if (this.bookingDetails.isGift) {
        this.createGift();
      } else {
        this.createReservation();
      }
    } catch (error) {
      this.handlePaymentError((error && (error as any).message) || 'Payment flow failed');
    } finally {
      this.isDwspayConfirmingPayment = false;
    }
  }
}
